import { TextField, Typography, InputAdornment } from '@mui/material';

function CustomTextArea({
    name, placeholder, type, onChange, onBlur, value, error, helperText,
    rows, isDisabled, noBorder, autoFocus, maxLength = 500

}) {
    const ModifiedTextField = {
        '& .MuiOutlinedInput-root': {
            fontSize: '1rem',
            alignItems: 'flex-start',
            fontFamily: 'Inter',
            '& fieldset': {
                borderColor: !noBorder ? '#C0C0C0' : '#00000000',
            },
            '&:hover fieldset': {
                borderColor: !noBorder ? '#C0C0C0' : '#00000000',
            },
            '&.Mui-focused fieldset': {
                borderColor: !noBorder ? '#C0C0C0' : '#00000000',
            },
        },
        "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#272727",
        },
    };
    return (
        <div>
            <TextField
                autoFocus={autoFocus}
                style={{ outline: 'none' }}
                className="modified_text_area"
                disabled={isDisabled}
                name={name}
                fullWidth
                multiline
                rows={rows}
                autoComplete="off"
                size="small"
                placeholder={placeholder}
                onChange={onChange}
                // onBlur={onBlur}
                value={value ?? ''}
                error={error}
                type={type}
                helperText={helperText}
                // error={error || isAtLimit} // highlight red if limit reached
                // helperText={dynamicHelperText}
                variant="outlined"
                sx={ModifiedTextField}
                inputProps={{
                    maxLength: maxLength || undefined,
                }}
            />

            {/* Warning message */}
            {/* {!isAtLimit &&  */}
            <Typography
                variant="caption"
                sx={{
                    display: 'block',
                    textAlign: 'right',
                    mt: 0.5,
                    color: 'text.secondary',
                    // isAtLimit ? '#d32f2f' :
                    fontFamily: 'Inter',
                }}
            >
                {value?.length || 0}/{maxLength}
            </Typography>
            {/* } */}
        </div >
    );
}

export default CustomTextArea;


// import { TextField, InputAdornment } from '@mui/material';
// import React, { useRef } from 'react';

// function CustomTextArea({
//     name,
//     placeholder,
//     type,
//     onChange,
//     onBlur,
//     value,
//     error,
//     helperText,
//     rows,
//     isDisabled,
//     noBorder,
//     autoFocus = false,
//     StartIcon,
//     keyCooldown = 0 // cooldown in milliseconds
// }) {
//     const cooldownRef = useRef(0);

//     const allowedKeys = new Set([
//         'Shift', 'Control', 'Alt', 'Meta', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
//         'Tab', 'CapsLock', 'Escape', 'Delete', 'Enter'
//     ]);

//     const handleKeyDown = (e) => {
//         if (allowedKeys.has(e.key)) return;

//         const now = Date.now();
//         if (now - cooldownRef.current < keyCooldown) {
//             e.preventDefault(); // Block rapid key repetition
//             return;
//         }
//         cooldownRef.current = now;
//     };

//     const ModifiedTextField = {
//         '& .MuiOutlinedInput-root': {
//             fontSize: '1rem',
//             alignItems: 'flex-start',
//             fontFamily: 'Inter',
//             '& fieldset': {
//                 borderColor: !noBorder ? '#C0C0C0' : '#00000000',
//             },
//             '&:hover fieldset': {
//                 borderColor: !noBorder ? '#C0C0C0' : '#00000000',
//             },
//             '&.Mui-focused fieldset': {
//                 borderColor: !noBorder ? '#C0C0C0' : '#00000000',
//             },
//         },
//         "& .MuiInputBase-input.Mui-disabled": {
//             WebkitTextFillColor: "#272727",
//         },
//     };

//     return (
//         <div>
//             <TextField
//                 autoFocus={autoFocus}
//                 style={{ outline: 'none' }}
//                 className="modified_text_area"
//                 disabled={isDisabled}
//                 name={name}
//                 fullWidth
//                 multiline
//                 rows={rows}
//                 autoComplete="off"
//                 size="small"
//                 placeholder={placeholder}
//                 onChange={onChange}
//                 value={value ?? ''}
//                 error={error}
//                 type={type}
//                 helperText={helperText}
//                 variant="outlined"
//                 sx={ModifiedTextField}
//                 onKeyDown={handleKeyDown}
//             />
//         </div>
//     );
// }

// export default CustomTextArea;

